import React from 'react';

// state: '' | 'correct' | 'incorrect' — derived by the parent from the answer.
// Optional dir/lang let callers render Dari glyphs right-to-left.
// Optional `trailing` renders an extra node (e.g. a 🔊 button) after the label;
// it should stop propagation so it doesn't trigger the option's onClick.
function Option({ label, state, onClick, dir, lang, trailing }) {
  const className = 'option' + (state ? ` option-${state}` : '');
  return (
    <div onClick={onClick} className={className} dir={dir} lang={lang}>
      <span className='option-label'>{label}</span>
      {trailing}
    </div>
  );
}

export default Option;
